//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { Placement } from 'tippy.js';
import { U } from 'ts-toolbelt';

import {
  HelpTermsType,
  MultiTermHelpIconWithMargin,
} from '@components/atoms/help-icon/MultiTermHelpIcon';
import Text from '@components/atoms/text/Text';
import { Mixins } from '@theme/mixins';
import { isDefined } from '@utils/filterPredicates';

interface IOwnProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  placement?: Placement;
  isDisabled?: boolean;
}

interface IWithHelpText extends IOwnProps {
  helpText?: string;
}

interface IWithHelpTerms extends IOwnProps {
  helpTerms?: HelpTermsType;
}

type Props = U.Strict<IOwnProps | IWithHelpText | IWithHelpTerms>;
/**
 * The BodyLabelText atom renders a standardized line of text for a StatBubble label
 */
export const BodyLabelText = ({
  className,
  helpTerms,
  helpText,
  isDisabled,
  placement,
  title,
}: Props) => {
  // build a single help term if provided `helpText`
  const builtHelpTerms = isDefined(helpText)
    ? [{ helpText: helpText }]
    : helpTerms;

  return (
    <LabelContainer className={className}>
      <Text mixin={isDisabled ? Mixins.Text.BodyDisabled : Mixins.Text.Body}>
        {title}
      </Text>
      {builtHelpTerms && (
        <StyledHelpIconWithMargin
          helpTerms={builtHelpTerms}
          placement={placement}
        />
      )}
    </LabelContainer>
  );
};

const LabelContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;

const StyledHelpIconWithMargin = styled(MultiTermHelpIconWithMargin)(
  ({ theme }) => `
  position: relative;
  bottom: ${theme.spacings[1]};
`,
);

export default BodyLabelText;
